var exports = {
  "z": "x804f0401--a78b72--root",
};

module.exports = exports;
